module.exports = __webpack_public_path__ + "static/media/testimonial4.266893ed.jpg";